import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  DidoxDbPosition,
  DidoxDocumentResponse,
  DidoxPurchasePayload,
  GtinSearchModel,
} from '../../models/didox/didox.model';

@Injectable({
  providedIn: 'root',
})
export class DidoxService {
  private baseUrl = environment.apiUrl;
  private http = inject(HttpClient);
  isAuthorized = signal<boolean>(
    !!window.sessionStorage.getItem('didox_token'),
  );
  updateAuthStatus(status: boolean) {
    this.isAuthorized.set(status);
  }
  checkCredentials(form: any) {
    return this.http.post(this.baseUrl + 'api/didox/settings', form);
  }

  getCredentials() {
    return this.http.get(this.baseUrl + 'api/didox/settings');
  }

  authCredentials() {
    return this.http.get<any>(this.baseUrl + `api/didox/token`);
  }

  getDocumentsPage(
    page: number,
    limit: number,
    dateFromCreated?: number | string,
    dateToCreated?: number | string,
    name?: string,
  ) {
    let dateFromCreated1 =
      dateFromCreated == undefined ? '' : '&dateFromCreated=' + dateFromCreated;
    let dateToCreated1 =
      dateToCreated == undefined ? '' : '&dateToCreated=' + dateToCreated;
    let name1 = name == undefined ? '' : '&name=' + name;
    return this.http.get(
      this.baseUrl +
        'api/didox/documents?page=' +
        page +
        '&limit=' +
        limit +
        dateFromCreated1 +
        dateToCreated1 +
        name1,
    );
  }

  getDocument(id: number | string) {
    return this.http.get<DidoxDocumentResponse>(
      this.baseUrl + 'api/didox/documents/' + id,
    );
  }

  getPositionMxik(ids: string[]) {
    return this.http.post<DidoxDbPosition[]>(
      this.baseUrl + 'api/didox/positions/mxic',
      ids,
    );
  }

  getPositionGtin(body: GtinSearchModel[]) {
    return this.http.post<DidoxDbPosition[]>(
      this.baseUrl + 'api/didox/positions/gtin',
      body,
    );
  }

  purchaseDidox(form: DidoxPurchasePayload) {
    return this.http.post<{ id: number }>(
      this.baseUrl + 'api/operations/purchase/didox',
      form,
    );
  }

  logout() {
    return this.http.delete(this.baseUrl + 'api/didox/settings');
  }
}
